var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 17
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABHNCSVQICAgIfAhkiAAAAT1JREFUOE+lk71KA1EQRl1/wBewsLARUgYrX8BX0EKFCEqitZ0I/kQFSzEEsVGsJAF9hwjBB7CV1NFCsBCEEF3PJ3PDdbPZZM3CYebOvfdkZtkEYRiO2DNDXIV5UPERKtC0/QwxB1n4hAeowrv2AxNtkp/DpLNa/CCuwVSP/TfqS1CTaJHkLiLwl1/W4bhXPCNfhmnraEGiJ2s3wdW1pdegbmswpxElapOMpbHY2R3iPTxDS6LO204pe+X8LWzr3jCiP78rUYPKbMpuosfrEmnW0yFELe6uuO/oisXGP2WH3Cs6kb6RMhRgNIWwyFmJOl+2u3tNsj6g6EidwHecSLVL2Ooj22f/2D/jRvNrEywuIB8j099FAvHbiXviREljapyDuG6TROqsZGMGxD046TVyksjduSF5gd3oOL70B3EjaMS9LRYNAAAAAElFTkSuQmCC"
  })));
};

export default SvgHeart;